import api from '@pray/shared/utils/api';

import type { ListWorkflowsResponse } from './data/response';

type ListWorkflowsProps = {
  artistId: string;
  limit?: number;
  offset?: number;
};

export async function listWorkflows({
  artistId,
  limit = 25,
  offset = 0,
}: ListWorkflowsProps): Promise<ListWorkflowsResponse> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/workflows`;
  const params = {
    limit,
    offset,
  };

  const response = await api.executeGetRequest<ListWorkflowsResponse>(url, params);
  return response.data;
}
